import {connect} from 'react-redux';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import {setHorizontalMode} from '../../actions/Search';

const defaultProps = {
    setHorizontalMode: isHorizontalMode => {
    }
};

class SearchForMap extends Component {
    toggleHorizontalMode(event) {
        event.preventDefault();

        if (window.innerWidth < 1171) {
            window.location.hash = 'map';
        } else {
            this.props.setHorizontalMode(!this.props.isHorizontalMode);
        }
    }

    render() {
        const {i18n, isHorizontalMode} = this.props;

        return (
            <div
                onClick={::this.toggleHorizontalMode}
                className={!isHorizontalMode ?
                    "search_for_map" :
                    "search_for_map refresh_text"}
            >
                {
                    !isHorizontalMode ?
                        <span>{i18n['search.searchByMap']}</span> :
                        <p>{i18n['search.back']}</p>
                }
            </div>
        );
    }
}

SearchForMap.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    isHorizontalMode: state.searchPage.isHorizontalMode
});

const mapDispatchToProps = {
    setHorizontalMode
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchForMap));



// WEBPACK FOOTER //
// ./src/components/Search/SearchForMap.js